import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=18211e1a&scoped=true&"
import script from "./BoardCard.vue?vue&type=script&lang=js&"
export * from "./BoardCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=18211e1a&lang=scss&scoped=true&"
import style1 from "./BoardCard.vue?vue&type=style&index=1&id=18211e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18211e1a",
  null
  
)

export default component.exports